<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1400px"
      title="质检"
      id-key="ReportId"
      :data="data"
      @closed="onClosed"
      @edit-opened="openEditOpened"
      :showSaveButton="false"
    >
    <!-- :get-data-func="api.info" -->
      <template slot="form">
        <div class="row-tb-head">
            <div class="flex">
                <div class="mrx36 flex">
                    <div style="min-width: 75px;">工单编码</div>
                    <el-input v-model="workNo" placeholder="输入工单编码" @change="chooseSets"></el-input>
                </div>
                <span style="margin-right: 80px;">可以扫码或者输入后自动回车显示到下面表格</span>
                <div class="mrx36">
                    <span class="inline_block">质检人：</span>
                    <span class="inline_block">{{data.Dts.length > 0? operator : ''}}</span>
                </div>
                <div class="mrx36 flex">
                    <div style="min-width: 75px;">检验日期</div>
                    <el-date-picker
                      v-model="testDate"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                </div>
            </div>
        </div>
        <el-table class="table-line tb-c-head" :data="data.Dts" border v-if="displayMode === 1">
          <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="模具编号" prop="MouldNo" min-width="120" show-overflow-tooltip />
          <el-table-column label="模具名称" prop="MouldName" min-width="120" />
          <el-table-column label="模数" prop="Quantity" min-width="70" />
          <el-table-column label="排产模数" prop="ThisPlanQuantity" width="80" />
          <el-table-column label="已检验数量" prop="ThisTestQuantity" width="90" />
          <!-- <el-table-column label="本次合格数量" prop="PassQuantity" width="100" /> -->
          <el-table-column label="本次合格模数" prop="PassQuantity" width="120" fixed="right">
            <template slot-scope="{ row }">
                <el-input v-model="row.UnTestQuantity" placeholder="请输入本次合格模数" @change="changeTestQuantity(row,$event)"></el-input>
            </template>
          </el-table-column>          
          <!-- <el-table-column label="本次合格克重" prop="PassGrammage" width="100" fixed="right">
            <template slot-scope="{ row }">
              <el-input v-model="row.PassGrammage" placeholder="请输入本次克重" @change="changeMouldPassGrammage($event, row)"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="本次合格数量(kg)" prop="PassQuantity2" width="120" fixed="right">
            <template slot-scope="{ row }">
                <el-input v-model="row.UnTestQuantity2" placeholder="请输入本次合格数量" @change="changeTestQuantity2(row,$event)"></el-input>
            </template>
          </el-table-column>      -->

          <el-table-column label="本次不合格模数" prop="ThisReportQuantityNumber2" width="120" fixed="right">
            <template slot-scope="{ row }">
                <el-input v-model="row.ThisReportQuantityNumber2" placeholder="请输入本次不合格数量"></el-input>
            </template>
          </el-table-column>  
          <!-- <el-table-column label="本次不合格克重" prop="FailGrammage" width="120" fixed="right">
            <template slot-scope="{ row }">
              <el-input v-model="row.FailGrammage" placeholder="请输入本次不合格克重" @change="changeMouldFailGrammage($event, row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="本次不合格数量(kg)" prop="FailQuantity2" width="140" fixed="right">
            <template slot-scope="{ row }">
                <el-input v-model="row.FailQuantity2" placeholder="请输入本次不合格数量(kg)" @change="changeFailQuantity2(row,$event)"></el-input>
            </template>
          </el-table-column>   -->
          <el-table-column label="质检情况" prop="Remark" width="120" fixed="right">
            <template slot-scope="{ row }">
                <el-input v-model="row.Remark" placeholder="请输入本次质检情况"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="table-line tb-c-head" :data="data.Dts" border v-if="displayMode === 2">
          <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="存货编号" prop="ProductNo" min-width="120" show-overflow-tooltip />
          <el-table-column label="存货名称" prop="ProductName" min-width="120" />
          <el-table-column label="生产数量" prop="Quantity" min-width="70" />
          <el-table-column label="排产数量" prop="ThisPlanQuantity" width="80" />
          <el-table-column label="已检验数量" prop="ThisTestQuantity" width="90" />
          <!-- <el-table-column label="本次合格数量" prop="PassQuantity" width="100" /> -->
          <el-table-column label="本次合格数量" prop="FailQuantity" width="120" >
            <template slot-scope="{ row }">
                <el-input v-model="row.UnTestQuantity" placeholder="请输入本次合格数量" @change="changeTestQuantity(row,$event)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="本次不合格数量" prop="ThisReportQuantityNumber2" width="120" >
            <template slot-scope="{ row }">
                <el-input v-model="row.ThisReportQuantityNumber2" placeholder="请输入本次不合格数量"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="质检情况" prop="Remark" width="120" >
            <template slot-scope="{ row }">
                <el-input v-model="row.Remark" placeholder="请输入本次质检情况"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    displayMode: {
        type: Number,
        default: 1
    }
  },
  data() {
    return {
      api: require("@/api/pr/test").default,
      // api: require("@/api/sy/user").default,
      workNo: "",
      testDate: this.$commonJs.getToday(),
      data: {
        
        ReportId: 0,
        PlanId: null,
        Stage: 0,
        StartDate: null,
        EndDate: null,
        ProcessName: "",
        ReportDate: null,
        Dts: [
        ],
        Materials: [],
        Products: [],
        operator: ''
      },
    };
  },
  computed: {},
  methods: {
    changeTestQuantity(row,val){
      if(val>=0){
        row.ThisReportQuantityNumber2=row.ThisPlanQuantity-val
      }
    },
    chooseSets(data) {
      this.api.getWorkDocProductTestList({
        WorkDocNo: data
      }).then(res => {
        this.data.Dts = []
        if (res.Data && res.Data.length > 0) {
          res.Data.forEach(item => {
            this.data.Dts.push(item)
          })
        } else {
          this.$message.warning('暂无数据！');
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    onClosed() {
      this.data.Dts = [];
      this.data.Materials = [];
      this.data.Products = [];
      this.workNo = '';
      this.testDate = this.$commonJs.getToday();
    },
    close() {
      this.$refs.dialog.close();
    },
    async openEditOpened(data) {
      // console.log(data, 'reportData');
      this.operator = JSON.parse(localStorage.getItem("loginInfo")).UserName;
      let o = {};
      let infoData = [];
      if (data.batch) {
        const ids = data.checkList.map(item => item.WorkDocId);
        o = {WorkDocIds: ids};
      } else {
        o = {
          WorkDocId: data.row.WorkDocId,
          WorkDocNo: data.row.WorkDocNo,
          PlanDtsId:data.row.PlanDtsId
        };
      }
      const res = await this.api.getWorkDocProductTestList(o);
      if (!res.IsSucc) return this.$message.error(res.Msg);
      if (res.Data && res.Data.length > 0) {
        infoData = res.Data;
      }
        // this.edit({infoData: this.$refs.toCheckList.workInfo, batch: true})
      this.data.Dts = infoData.map(item => {
        return {
          ...item,
          ThisReportQuantityNumber2: 0,          
          PlanDtsId:data.row.PlanDtsId
        }
      });
      this.data.batch = data.batch;
    },
    async onSubmit() {
      let isReturn = false;
      const arr = this.data.Dts.map(item => {
        if (item.UnTestQuantity == null || item.UnTestQuantity == undefined) {
          this.$message.error('请输入本次合格数量')
          isReturn = true;
          return
        }
        if (item.ThisReportQuantityNumber2 == null || item.ThisReportQuantityNumber2 == undefined) {
          console.log(item.ThisReportQuantityNumber2);
          this.$message.error('请输入本次不合格数量')
          isReturn = true;
          return
        }
        return {
          WorkDocId: item.WorkDocId,
          PassQuantity: Number(item.UnTestQuantity),
          FailQuantity: Number(item.ThisReportQuantityNumber2),
          // PassQuantity2: Number(item.UnTestQuantity2),
          // FailQuantity2: Number(item.ThisReportQuantityNumber2),
          Remark: item.Remark,
          PlanDtsId:item.PlanDtsId
        }
      });
      if (isReturn) return;
      if (this.testDate == '') return this.$message.warning('请输入检验日期');
      const res = await this.api.submit({TestSaves: arr, TestDate: this.$dayjs(this.testDate).format('YYYY-MM-DD')});
      if (!res.IsSucc) return this.$message.error(res.Msg);
      this.$message.success('保存成功！')
      this.$refs.dialog.isChange = false;
      this.close();
      this.$emit('saved');
    },
  },
};
</script>

<style lang="scss" scoped>
.flex{
    display: flex;
}
.inline_block{
    display: inline-block;
}
.mrx36{
    margin-right: 36px;
}
</style>